export enum PullRequestTab {
  All = 'all',
  InProgress = 'in-progress',
  Merged = 'merged',
}
